import { render } from "./discuss_transaction.vue?vue&type=template&id=46024f8a"
import script from "./discuss_transaction.vue?vue&type=script&lang=js"
export * from "./discuss_transaction.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__